import Form from 'react-bootstrap/Form';

function TextInput({ titleText, inputName, value, setValue }) {

    const handleChange = e => {
        setValue(e.target.value);
    }

    return (
        <div className='data-line'>
            <span className='infoTitle'>
                {titleText}
            </span>
            <span className='infoData'>
                <Form.Control
                    className='py-1 px-3'
                    type='text'
                    value={value}
                    name={inputName}
                    onChange={handleChange}
                />
            </span>
        </div>
    );
}

export default TextInput;